import styled, { css } from 'styled-components'

import { PagePositions } from './types'

const getBorderRadius = ({
  position
}: {
  position: PagePositions
}) => {
  const value =
    position === PagePositions.left ? '8px 0 0 8px' : '0 8px 8px 0'

  return css`
    border-radius: ${value};
  `
}

export const Container = styled.div<{ position: PagePositions }>`
  width: 134px;
  cursor: pointer;

  @media (max-width: 1194px) {
    width: 103px;
  }
`

export const Preview = styled.div`
  width: 100%;
  height: 190px;

  ${getBorderRadius}

  overflow: hidden;

  @media (max-width: 1194px) {
    height: 146px;
  }
`

export const Info = styled.div`
  width: 100%;
  margin-top: 4px;
`
